import * as Yup from 'yup';

export const address = Yup.string().max(
  200,
  'Address should be less than 200 symbols',
);
